import { render } from "./AddDiscount.vue?vue&type=template&id=2c05b7c9&scoped=true"
import script from "./AddDiscount.vue?vue&type=script&lang=js"
export * from "./AddDiscount.vue?vue&type=script&lang=js"

import "./AddDiscount.vue?vue&type=style&index=0&id=2c05b7c9&scoped=true&lang=css"

import exportComponent from "/home/u624473994/domains/backoffice.quickpay.pe/quickshop-admin-main/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c05b7c9"]])

export default __exports__